import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const SourcesOfMentalNoiseSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel sectionId="sources-of-mental-noise" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      Mental noise rarely begins with the present moment. It is usually triggered by past
      experiences whose interpretations were never examined.
    </GuideLead>
    <p className="guide-panel__p">
      The sequence is usually the same: a present event resembles a past one, the old interpretation
      fires automatically, and the mind starts replaying to resolve it. Knowing the source does not
      stop the noise by itself — but it tells you which interpretation to put on the table and examine.
    </p>
    <GuideSectionLabel>Common sources</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="stress"
        title="Past Experiences"
        description="Previous failures, rejection, criticism, conflict, or disappointment influence how the brain interprets new situations."
      />
      <GuideCard
        iconKey="energy"
        title="Current Stress"
        description="When under pressure, the brain becomes more sensitive to perceived threats and uncertainty."
      />
      <GuideCard
        iconKey="thinking"
        title="Uncertainty"
        description="The brain dislikes unanswered questions and often creates stories to fill the gaps."
      />
      <GuideCard
        iconKey="communication"
        title="Fear of Judgment"
        description="Concern about what others think can amplify self-doubt and internal criticism."
      />
      <GuideCard
        iconKey="awareness"
        title="Unexamined Interpretations"
        description="Interpretations from past events that were never tested against evidence often resurface in similar situations."
      />
    </GuideCardGrid>
  </GuidePanel>
);

export default SourcesOfMentalNoiseSection;
